import jQuery from "jQuery";
import * as common from "./common.js";
import * as unity from "./unity.js";
import {facebook} from "../main";
/*global FB*/
/*global paypalPay*/
/*global PAYPAL*/

const unityStorePlugin = "pswebstoreplugin";
const paymentPlatforms = new Map();

class PaymentPlatform {

    constructor(name) {
        this.name = name;
        this.methods = new Map();
        paymentPlatforms.set(name, this);
    }

    execute(method, sku, data) {
        if (!this.methods.has(method)) {
            throw `Unsupported payment method "${method}" for the platform ${this.name}`;
        }
        this.methods.get(method)(sku, data);
    }

    hasMethod(method) {
        return this.methods.has(method);
    }

    addMethod(paymentMethod, runnable) {
        this.methods.set(paymentMethod, runnable);
    }
}

export function execute(platform, method, sku, rawData) {
    console.log("[w] execute payment:", platform, method, sku, rawData);
    if (!paymentPlatforms.has(platform)) {
        throw `Unsupported payment platform ${platform}`;
    }
    return paymentPlatforms.get(platform).execute(method, sku, JSON.parse(rawData));
}

export function hasMethod(platform, method) {
    console.log("[w] ehasMethod:", platform, method);
    if (!paymentPlatforms.has(platform)) {
        console.log("[w] Unsupported payment platform:", platform);
        return false;
    }
    return paymentPlatforms.get(platform).hasMethod(method);
}

export function init() {

// Facebook

    if (facebook.isCanvas()) {
        const ppFacebook = new PaymentPlatform("FACEBOOK");

        ppFacebook.getPurchaseResultFromObject = function (obj) {
            let result = "Success";
            // This may happen if no currency available
            if (obj.status === "redeemed_to_balance") {
                result = "RedeemedToBalance";
            } else {
                // User cancelled the operation
                switch (obj.error_code) {
                    case 1383010:
                        result = "UserCancelled";
                        break;
                }
            }
            return result;
        };

        ppFacebook.getProductUrl = function (params) {
            return common.getApiUrl(`/facebook/game/${common.config.gameName}/payment/${common.config.platformData.appId}`, params);
        };

        ppFacebook.addMethod("Consumable", function (sku, data) {

            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            /** @namespace data.isGift */
            let product = ppFacebook.getProductUrl({hash: data.hash});

            let obj;

            if (data.isGift) {
                obj = {
                    method: "gift",
                    product: product,
                };

                if (data.giveTo !== undefined)
                    obj.to = data.giveTo;
            } else {
                obj = {
                    method: "pay",
                    action: "purchaseitem",
                    product: product,
                };
            }

            FB.ui(obj, function (e) {
                console.log("[w] FB payment response: ", obj, e);
                const result = ppFacebook.getPurchaseResultFromObject(e);
                unity.sendData(unityStorePlugin, {sku: sku, result: result, receipt: e});
            });
        });

        ppFacebook.addMethod("Subscription", function (sku, data) {

            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            /** @namespace data.action */
            /** @namespace data.idSubscription */

            let obj = {
                method: "pay",
                action: data.action
            };

            if (typeof hash === "string") {
                obj["product"] = this.getProductUrl({hash: data.hash});
            }

            if (typeof data.idSubscription === "string") {
                obj["subscription_id"] = data.idSubscription;
            }

            FB.ui(obj, function (e) {
                const result = ppFacebook.getPurchaseResultFromObject(e);
                unity.sendData(unityStorePlugin, {sku: sku, result: result, receipt: e});
            });
        });

        ppFacebook.addMethod("Mobile", function (sku, data) {
            const params = {
                idUserPlatform: common.config.platformData.idFbUser,
                currencyType: data.currencyType !== 1 ? "COINS" : "CREDITS",
                country: common.loginData.country,
                locale: common.config.locale
            };

            let url = common.getApiUrl(`/facebook/game/${common.config.gameName}/getMobilePacks/${common.config.platformData.appId}`, params);

            jQuery.colorbox({
                iframe: true,
                top: 0,
                width: "600px",
                height: "600px",
                href: url
            });
        });

// --------------------------- WEb PAYMENTS -----------------------------
    } else {
// --------------------------- PAYPAL -----------------------------

        let ppPayPal = new PaymentPlatform("PAYPAL");

        ppPayPal.addMethod("Consumable", function (sku, data) {

            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            paypalPay.action = `/api/payment/paypal/${common.config.gameName}/${common.config.environment}/pack/${(data.idCurrencyPack)}/${(data.idCurrencyPackFilter)}?currencyType=${encodeURIComponent(data.currency)}`;
            jQuery("#submitBtn").click();

            unity.sendData(unityStorePlugin, {sku: sku, result: "success"});
        });

        common.loadScript("https://www.paypalobjects.com/js/external/dg.js", function () {

            jQuery("body").append(
                `<div style="display:none">
                <form name="paypalPay" action="#" method="post" target="PPDGFrame" class="standard" style="visibility:hidden">
                <p><input id="type" type="hidden" name="expType" value="light"></p><p><input id="submitBtn" type="submit" value="Pay with PayPal" /></p>
                </form></div>`
            );

            document.dg = new PAYPAL.apps.DGFlow({
                // HTML ID of form submit buttons that call setEC
                trigger: "submitBtn"
            });
        });

// -------------------------- BOACOMPRA ----------------------------------

        let ppBoaCompra = new PaymentPlatform("BOACOMPRA");

        ppBoaCompra.addMethod("Consumable", function (sku, data) {
            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            /** @namespace data.paymentMethod */


            let idCurrencyPack = data.idCurrencyPack,
                idCurrencyPackFilter = data.idCurrencyPackFilter;

            let params = {
                "currencyType": data.currencyType,
                "paymentMethod": data.paymentMethod
            };

            let url = common.getApiUrl(`/api/payment/boacompra/${common.config.gameName}/${common.config.environment}/${idCurrencyPack}/${idCurrencyPackFilter}`);


            let w = 1000 <= screen.width ? 1000 : screen.width;
            let h = screen.height * 0.7;

            if (facebook.isCanvas()) common.openWindow("paymentWin", w, h);

            common.fetchJson(url, params)
                .then(response => {
                    jQuery("#paymentform").parent("div").detach();
                    jQuery("body").append(
                        `<div style="display:none">
                            <form action="${response.url}" method="post" id="paymentform" target="paymentWin"  >
                            <input type="hidden" name="store_id" id="store_id" value="${response.store_id}">
                            <input type="hidden" name="return" id="return" value="${response.return}">
                            <input type="hidden" name="notify_url" id="notify_url" value="${response.notify_url}">
                            <input type="hidden" name="currency_code" id="currency_code" value="${response.currency_code}">
                            <input type="hidden" name="order_id" id="order_id" value="${response.order_id}">
                            <input type="hidden" name="order_description" id="order_description" value="${response.order_description}">
                            <input type="hidden" name="amount" id="amount" value="${response.amount}">
                            <input type="hidden" name="client_email" id="client_email" value="${response.client_email}">
                            <input type="hidden" name="hash_key" id="hash_key" value="${response.hash_key}">
                            <input type="hidden" name="test_mode" id="test_mode" value="${response.test_mode}" />
                            <input type="hidden" name="payment_id" id="test_mode" value="${response.payment_id}" />
                            <input type="hidden" name="language" id="language" value="${response.language}" />
                        </form></div>`
                    );

                    common.openWindow("paymentWin", w, h, "paymentform");
                    unity.sendData(unityStorePlugin, {sku: sku, result: "success"});
                });
        });

// --------------------------- ADYEN -----------------------------

        let ppAdyen = new PaymentPlatform("ADYEN");

        ppAdyen.addMethod("Consumable", function (sku, data) {

            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            /** @namespace data.paymentMethod */

            let paymentMethod = data.paymentMethod;

            let recurringUrl = common.getApiUrl(`/api/payment/adyen/${common.config.gameName}/${common.config.environment}/recurring/confirm/pack/${(data.idCurrencyPack)}/${(data.idCurrencyPackFilter)}`);

            jQuery("#paymentform").parent("div").detach();
            jQuery("body").append(
                `<div style="display:none">
                    <form action="${recurringUrl}" method="post" id="paymentform" target="paymentWin" style="visibility:hidden" >
                    <input type="hidden" name="currencyType" value="${data.currency}">
                    ${typeof paymentMethod === "string" ? "<input type=\"hidden\" name=\"paymentMethod\" value=\"" + paymentMethod + "\">" : ""}
                </form></div>`
            );

            let w = 800 <= screen.width ? 800 : screen.width;
            let h = screen.height * 0.9;

            common.openWindow("paymentWin", w, h, "paymentform");

            unity.sendData(unityStorePlugin, {sku: sku, result: "success"});
        });

// --------------------------- PAYMENTEZ -----------------------------

        let ppPaymentez = new PaymentPlatform("PAYMENTEZ");

        ppPaymentez.addMethod("Consumable", function (sku, data) {

            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            /** @namespace data.paymentMethod */

            let paymentMethod = data.paymentMethod;

            let url = common.getApiUrl(`/api/payment/paymentez/${common.config.gameName}/${common.config.environment}/start/${(data.currencyType)}/${(data.idCurrencyPack)}`);

            jQuery("#paymentform").parent("div").detach();
            jQuery("body").append(
                `<div style="display:none"><form action="${url}" method="post" id="paymentform" target="paymentWin" style="visibility:hidden" >
                    <input type="hidden" name="environment" value="${common.config.environment}">
                    ${typeof paymentMethod === "string" ? "<input type=\"hidden\" name=\"paymentMethod\" value=\"" + paymentMethod + "\">" : ""}
                </form></div>`
            );

            let w = 800 <= screen.width ? 800 : screen.width;
            let h = screen.height * 0.9;

            common.openWindow("paymentWin", w, h, "paymentform");

            unity.sendData(unityStorePlugin, {sku: sku, result: "success"});
        });

// --------------------------- FORTUMO -----------------------------

        let ppFortumo = new PaymentPlatform("FORTUMO");

        common.onLoginData(function (ld) {

            common.fetchJson(`/api/payment/fortumo/info/${common.config.idVideoGame}/${ld.idUser}`, {locale: common.config.locale})
                .then(data => {
                    if (typeof data.service_id === "string") {
                        jQuery("body").append(
                            `<div style="display:none">
                                <form action="https://fortumo.com/mobile_payments/${data.service_id}" method="post" id="fortumoForm" target="fortumoWin" style="visibility:hidden" >
                                    <input type="hidden" name="credit_name" value="${data.credit_name}">
                                    <input type="hidden" name="cuid" value="${data.cuid}">
                                    <input type="hidden" name="sig" value="${data.sig}">
                                </form>
                            </div>`
                        );
                    }
                });
        });

        ppFortumo.addMethod("Mobile", function () {
            common.openWindow("fortumoWin", 650, 580, "fortumoForm");
        });


// --------------------------- DAOPAY -----------------------------

        let ppDaopay = new PaymentPlatform("DAOPAY");

        jQuery("body").append(
            `<div style="display:none">
            <form action="" method="get" id="daopayForm" target="daopayWin" style="visibility:hidden">
                <input type="hidden" name="locale" value="${common.config.locale}">
            </form>
            </div>`
        );
        //
        // ppDaopay.addMethod("buyMobile", function (sku, data) {
        //
        //     let $daopayForm = jQuery("#daopayForm");
        //
        //     if (data.currencyType !== undefined) {
        //         $daopayForm.append(`<input type="hidden" name="currencyType" value="${data.currencyType}">`);
        //     }
        //
        //     if (data.byCall !== undefined) {
        //         $daopayForm.append(`<input type="hidden" name="call" value="${data.byCall}">`);
        //     }
        //
        //     if (data.country !== undefined) {
        //         $daopayForm.append("<input type=\"hidden\" name=\"country\" value=\"" + data.country + "\">");
        //     }
        //
        //     let urlDaopay = `/api/payment/daopay/${common.config.gameName}/${common.config.environment}/show`;
        //     $daopayForm.attr("action", urlDaopay);
        //
        //     openWin("daopayForm", "daopayWin", 650, 580);
        // });

        ppDaopay.addMethod("Consumable", function (sku, data) {

            /** @namespace data.currencyType */
            /** @namespace data.idCurrencyPack */
            /** @namespace data.idCurrencyPackFilter */
            /** @namespace data.paymentPlatform */
            /** @namespace data.paymentMethod */

            let currencyType = data.currencyType,
                paymentMethod = data.paymentMethod,
                country = data.country;


            let url = common.getApiUrl(`/api/payment/daopay/${common.config.gameName}/${common.config.environment}/start/${(data.idCurrencyPack)}/${(data.idCurrencyPackFilter)}`);

            jQuery("#paymentform").parent("div").detach();
            jQuery("body").append(
                `<div style="display:none">
                <form action="${url}" method="post" id="paymentform" target="paymentWin" style="visibility:hidden" >
                <input type="hidden" name="currencyType" value="${currencyType}">
                <input type="hidden" name="country" value="${country}">
                ${typeof paymentMethod === "string" ? "<input type=\"hidden\" name=\"paymentMethod\" value=\"" + paymentMethod + "\">" : ""}
                </form>
                </div>`
            );

            let w = 800;
            let h = 800;

            common.openWindow("paymentWin", w, h, "paymentform");
            unity.sendData(unityStorePlugin, {sku: sku, result: "success"});
        });
    }
}